import { useEffect, useState } from 'react';
import { getMarketAnalysisPosts } from '../api/contentApi';
import { parseMarketAnalysisPostSummary } from '../utils/marketAnalysisContent';

export const useMarketAnalysisPosts = () => {
  const [posts, setPosts] = useState([]);
  const [featuredPost, setFeaturedPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const loadedPosts = await getMarketAnalysisPosts();
        if (!isMounted) {
          return;
        }

        const parsedPosts = loadedPosts.map(parseMarketAnalysisPostSummary);
        setPosts(parsedPosts);
        setFeaturedPost(parsedPosts.find((post) => post.featured) || parsedPosts[0] || null);
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setPosts([]);
        setFeaturedPost(null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { posts, featuredPost, isLoading, error };
};
